import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { CustomerAddress } from "@/components/Address/Address/address.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import { load as loadBillingCountries } from "@/redux/modules/api/data/countries/billing/billingCountries.module";
import { getBillingCountries } from "@/redux/modules/api/data/countries/billing/billingCountries.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    address: CloudCustomerAddress;
    addressType: AddressType | null;
};

const AddressContainer = ({ address, addressType }: Props) => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const billingCountries = useSelector(getBillingCountries, shallowEqual);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        dispatch(loadBillingCountries());
    };
    return (
        <>
            {billingCountries.length > 0 && address && (
                <CustomerAddress
                    address={{
                        ...address,
                        ...{
                            country:
                                billingCountries.find(
                                    (country) =>
                                        country.isoCode === address.country
                                )?.name || t("general.country.be")
                        }
                    }}
                    addressType={addressType}
                />
            )}
        </>
    );
};

export { AddressContainer };
